import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// Custom hook that builds on useLocation to parse the query string

export default function useQueryString() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
